import { authHeader } from './auth-headers';

export function requestHeaders(headers = null) {
  const options = {
    headers: { ...authHeader() },
  };

  return options;
}
